import EventEmitter from 'eventemitter3'
const EE = new EventEmitter()

export const EVENTS = {
  // login后的API需要在sdk ready后调用
  onSdkReady: 'onSdkReady',
  // 所有消息，包括系统、群提示、群消息
  onMessageReceived: 'onMessageReceived',
  // 系统消息
  onSystemNoticeReceived: 'onSystemNoticeReceived',
  // 群提示
  onTipNoticeReceived: 'onTipNoticeReceived',
  // 群消息
  onGroupMessageReceived: 'onGroupMessageReceived',
  // 群组被解散/场次解散通知
  onDismissGroup: 'onDismissGroup',
  // 用户自定义通知
  onDefinedField: 'onDefinedField',
  // 用户加群通知
  onJoinGroup: 'onJoinGroup',
  // 用户离开群通知
  onQuitGroup: 'onQuitGroup'
}

export function emit (event, ...params) {
  EE.emit(event, ...params)
}

export function on (event, fn, context) {
  EE.on(event, fn, context)
}

export function off (event, fn, context) {
  EE.removeListener(event, fn, context)
}

export function once (event, fn, context) {
  EE.once(event, fn, context)
}
